import DotColor from "./DotColor";
import "../format/Logo.css";

const Logo = () => {
    return (
        <>
            <div className="logo">mixd<DotColor/></div>
        </>
    )
}

export default Logo